import { AULA_NOTIFICATION_HOVER_BG_COLOUR } from '@ublend-npm/aulaui-core';

export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const headerBorder = isDark ? '#F8F7F929' : '#231F2929';
  const { fontFamily } = theme?.typography;

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: { xs: '0 1 auto', md: 1 },
      minHeight: 0,
      overflow: 'hidden',
    },
    list: {
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: { xs: '30vh', md: 'none' },
    },
    header: {
      flexShrink: 0,
      mt: '12px',
      py: '13.5px',
      mx: '16px',
      mb: '4px',
      borderTop: `1px solid ${headerBorder}`,
      borderBottom: `1px solid ${headerBorder}`,
      fontFamily,
    },
    headerContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '7px',
      color: isDark ? '#FFFFFF' : '#000000',
      fontSize: '16px',
      fontWeight: '500',
    },
    headerIcon: {
      color: isDark ? '#FFFFFF8F' : '#231F298F',
    },
    emptyList: {
      textAlign: 'center',
      boxSizing: 'border-box',
      mt: '8px',
      mx: '16px',
      background: isDark
        ? theme.palette.common.black
        : AULA_NOTIFICATION_HOVER_BG_COLOUR,
    },
    emptyTitle: { fontWeight: 400 },
  };
};
